// extracted by mini-css-extract-plugin
export default {"wrapper":"Poem_wrapper__VxRT5","wrap":"Poem_wrap__r3Qoz","subTitle":"Poem_subTitle__g86uz"};